class ZoomImage extends HTMLElement {
    static get observedAttributes() {
      return ['src', 'zoom-src', 'alt'];
    }
  
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this._src = '';
      this._zoomSrc = '';
      this._alt = '';
      this._zoomDiv = null;
      this._raf = null;
    }
  
    connectedCallback() {
      // Always sync attributes first
      this._src = this.getAttribute('src') || '';
      this._zoomSrc = this.getAttribute('zoom-src') || this._src;
      this._alt = this.getAttribute('alt') || '';
  
      this.render();
  
      const img = this.shadowRoot.querySelector('img');
      this._zoomDiv = this.shadowRoot.querySelector('.zoom-layer');
  
      // Event handlers
      this._handleMouseEnter = () => {
        this._zoomDiv.style.backgroundImage = `url(${this._zoomSrc})`;
        this._zoomDiv.style.backgroundSize = '200%';
        this.shadowRoot.querySelector('img').style.opacity = '0';
      };
  
      this._handleMouseMove = (e) => {
        if (this._raf) cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => {
          const rect = img.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          this._zoomDiv.style.backgroundPosition = `${x}% ${y}%`;
        });
      };
  
      this._handleMouseLeave = () => {
        this._zoomDiv.style.backgroundImage = '';
        this.shadowRoot.querySelector('img').style.opacity = '1';
      };
  
      // Attach events
      img.addEventListener('mouseenter', this._handleMouseEnter);
      img.addEventListener('mousemove', this._handleMouseMove);
      img.addEventListener('mouseleave', this._handleMouseLeave);
    }
  
    disconnectedCallback() {
      if (this._raf) {
        cancelAnimationFrame(this._raf);
        this._raf = null;
      }
      const img = this.shadowRoot?.querySelector('img');
      if (img) {
        img.removeEventListener('mouseenter', this._handleMouseEnter);
        img.removeEventListener('mousemove', this._handleMouseMove);
        img.removeEventListener('mouseleave', this._handleMouseLeave);
      }
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) return;
  
      if (name === 'src') this._src = newValue;
      if (name === 'zoom-src') this._zoomSrc = newValue;
      if (name === 'alt') this._alt = newValue;
  
      this.render();
    }
  
    render() {
      if (!this.shadowRoot) return;
      this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: block;
            position: relative;
            overflow: hidden;
            cursor: crosshair;
          }
          .zoom-layer {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100%;
            pointer-events: none;
            transition: background-position 0.1s ease;
            will-change: background-position;
          }
          img {
            display: block;
            width: 100%;
            height: auto;
          }
        </style>
        <img src="${this._src}" alt="${this._alt}" />
        <div class="zoom-layer"></div>
      `;
    }
  }
  
  customElements.define('zoom-image', ZoomImage);
  